<template>
  <div>
    <ControlOption
      :campos="campos"
      :camposIndex="camposIndex">
      <p class="my-1">Pregunta: {{campos.pregunta + (campos.obligatorio== 1 ? '  **' : '')}}</p>
      <v-text-field
        placeholder="YYYY-MM-DD"
        disabled
        solo
        append-outer-icon="far fa-calendar-alt"
      ></v-text-field>

    </ControlOption>

  </div>
</template>

<script>
import ControlOption from "@/components/dragdrop/Campos/ControlOption.vue";

export default {
  name:"Calendarios",
  props: {
    campos: {
      type: Object,
      required: true
    },
    camposIndex: {
      type: Number,
      required: true
    },  
  },
  components: {
    ControlOption,
  },
  data() {
    return {
    }
  },
    
}
</script>

<style lang="scss" scoped>

</style>
